import React from 'react'
import { GeneralTable } from '@digitalmedia/sn-design-system'

export default function MedalTable({ data, emptyTableMessage }) {
    const renderMedalImage = medalColour => {
        switch (medalColour) {
            case 'bronze':
                return (
                    <svg
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M0.5 0H9.79032L17.5323 11.2258H8.24194L0.5 0Z" fill="#06192F" />
                        <path d="M24.5 0H15.2097L7.46774 11.2258H16.7581L24.5 0Z" fill="#06192F" />
                        <circle cx="12" cy="14.5" r="9.5" fill="#8C5F0C" />
                        <path
                            d="M12.7 18.5H9.34003V10.064H12.256C13.84 10.064 14.668 10.652 14.668 11.852V12.392C14.668 13.256 14.152 13.772 13.42 14V14.036C14.428 14.192 15.124 14.744 15.124 15.788V16.52C15.124 18.032 13.936 18.5 12.7 18.5ZM11.944 11.36H10.864V13.508H11.884C12.748 13.508 13.132 13.076 13.132 12.56V12.164C13.132 11.576 12.748 11.36 11.944 11.36ZM12.172 14.78H10.864V17.192H12.076C12.94 17.192 13.528 17.012 13.528 16.232V15.764C13.528 15.2 13.132 14.78 12.172 14.78Z"
                            fill="white"
                        />
                    </svg>
                )
            case 'silver':
                return (
                    <svg
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M0.5 0H9.79032L17.5323 11.2258H8.24194L0.5 0Z" fill="#06192F" />
                        <path d="M24.5 0H15.2097L7.46774 11.2258H16.7581L24.5 0Z" fill="#06192F" />
                        <circle cx="12" cy="14.5" r="9.5" fill="#717A83" />
                        <path
                            d="M14.8471 16.04C14.8471 17.552 13.9831 18.704 11.8951 18.704C9.65114 18.704 9.18314 17.684 9.18314 16.868V15.944L10.6831 15.872V16.496C10.6831 17.012 10.9351 17.42 11.9311 17.42C12.4471 17.42 12.7951 17.288 12.9751 17.024C13.1551 16.772 13.2391 16.472 13.2391 16.148C13.2271 15.476 12.9271 15.164 12.1951 14.912L10.9351 14.468C9.77114 14.072 9.19514 13.376 9.19514 12.212C9.19514 11.54 9.42314 10.976 9.87914 10.532C10.3231 10.088 11.0551 9.86 12.0751 9.86C14.1031 9.86 14.6791 10.784 14.6791 11.636V12.596L13.2271 12.644V11.96C13.2271 11.516 12.9511 11.06 12.0511 11.06C11.1511 11.06 10.8031 11.504 10.7911 12.092C10.7791 12.716 11.1391 13.04 11.8471 13.292L13.0591 13.7C14.1991 14.096 14.8471 14.696 14.8471 16.04Z"
                            fill="white"
                        />
                    </svg>
                )
            case 'gold':
                return (
                    <svg
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M0.5 0H9.79032L17.5323 11.2258H8.24194L0.5 0Z" fill="#06192F" />
                        <path d="M24.5 0H15.2097L7.46774 11.2258H16.7581L24.5 0Z" fill="#06192F" />
                        <circle cx="12" cy="14.5" r="9.5" fill="#FFC931" />
                        <path
                            d="M13.6333 15.392H11.8453V14.132H15.0733V18.5H14.1973L14.0293 17.756C13.5373 18.296 12.8173 18.704 11.8093 18.704C9.60127 18.704 8.92927 17.408 8.92927 15.776V12.908C8.92927 11.408 9.72127 9.86 12.1333 9.86C14.4373 9.86 15.0493 11.216 15.0493 12.332V12.896L13.5013 12.968V12.404C13.5013 12.092 13.4053 11.816 13.2133 11.564C13.0213 11.312 12.6493 11.192 12.0973 11.192C11.0053 11.192 10.5373 11.804 10.5373 12.8V15.74C10.5373 16.856 10.9693 17.396 12.0253 17.396C12.6013 17.396 13.0093 17.24 13.2613 16.94C13.5133 16.64 13.6333 16.316 13.6333 15.944V15.392Z"
                            fill="#06192F"
                        />
                    </svg>
                )
            default:
                return null
        }
    }

    return (
        data.length > 0 && (
            <GeneralTable
                data={data}
                columns={[
                    {
                        title: 'POS',
                        dataKey: 'league_rank',
                        bold: true,
                        textAlign: 'center',
                        initialSortDirection: 'asc',
                        cellWidthOverride: 12.5,
                    },
                    {
                        title: 'NAME',
                        dataKey: 'name',
                        customLabel: 'customLabel',
                        bold: false,
                        textAlign: 'left',
                        cellWidthOverride: 37.5,
                    },
                    {
                        title: renderMedalImage('gold'),
                        dataKey: 'gold',
                        bold: false,
                        textAlign: 'center',
                        cellWidthOverride: 12.5,
                    },
                    {
                        title: renderMedalImage('silver'),
                        dataKey: 'silver',
                        bold: false,
                        textAlign: 'center',
                        cellWidthOverride: 12.5,
                    },
                    {
                        title: renderMedalImage('bronze'),
                        dataKey: 'bronze',
                        bold: false,
                        textAlign: 'center',
                        cellWidthOverride: 12.5,
                    },
                    {
                        title: 'TOT',
                        dataKey: 'total',
                        bold: false,
                        textAlign: 'center',
                        cellWidthOverride: 12.5,
                    },
                ]}
                customTableHeaderStyles={{
                    color: '#06192F',
                    fontFamily: 'protipo-narrow, sans-serif',
                    margintop: 0,
                    fontSize: '14px',
                    padding: '0',
                    height: '32px',
                    lineHeight: '32px',
                    bottom: '0px',
                }}
                customTableStyles={{
                    color: '#495057',
                    fontFamily: 'protipo-narrow, sans-serif',
                    padding: '0',
                    borderRadius: '8px',
                    border: 'none',
                }}
                customTableRowStyles={{
                    color: '#495057',
                }}
                emptyMessage={emptyTableMessage}
                enableSorting={true}
                sortIconStyle="line"
                initialSortColumn={'league_rank'}
            />
        )
    )
}
